import { render } from "./Index.vue?vue&type=template&id=a09da644"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/CancellationPolicy/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a09da644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a09da644', __exports__)) {
    api.reload('a09da644', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=a09da644", () => {
    api.rerender('a09da644', render)
  })

}


export default __exports__